import { environment } from '../../../environments/environment';

export function getProjectsUrl(hostId: string, url = ''): string {
  return `${environment.projectProviderUrl[hostId]}/v3/api/v4/rooms${url}`;
}
